<template>
  <b-modal v-model="modalAberto" size="xl" @hidden="cancelar" button-size="md" hide-footer
    :title="prefix + title">
    <b-card no-body>
      <b-card-body>
        <b-row>
          <b-col cols="12" md="6">
            <b-card bg-variant="light">
              <b-img :src="fotoSelecionada" fluid alt="Foto do Produto" class="mb-3 b-img-max-half" />
              <div class="d-flex flex-wrap justify-content-start">
                <div v-for="(foto, index) in result.imagens" :key="index" class="thumbnail-container">
                  <b-img :src="convertByteArrayToImage(foto)" thumbnail
                    @click="selecionarFoto(convertByteArrayToImage(foto))" />
                </div>
              </div>
            </b-card>
          </b-col>
          <b-col cols="12" md="6">
            <b-card bg-variant="light">
              <h4>{{ result.produtoCatalogo.apelido }}</h4>
              <div class='especificacao-container'>
                <p class='especificacao'>{{ result.produtoCatalogo.especificacao }}</p>
              </div>
              <template v-if="mostrarDetalhes">
                <b-form-group label="Valor Unitário:">
                  <b-form-input :value="formatCurrency(result.produtoCatalogo.valorEstimado)" readonly></b-form-input>
                </b-form-group>
                <b-form-group label="Quantidade:">
                  <b-form-input :disabled="!temPrivilegioAcessarCarrinho()" type="number" v-model="form.quantidade" min='0'></b-form-input>
                </b-form-group>
                <b-form-group label="Valor Total Estimado:">
                  <b-form-input :value="formatCurrency(valorTotal)" readonly></b-form-input>
                </b-form-group>
              </template>
              <div class='text-right'>
                <b-button v-if="temPrivilegioAcessarAnexo()" variant="secondary" @click="abrirModalAnexo">
                  <b-icon icon="paperclip"></b-icon>
                </b-button>
              </div>
            </b-card>
          </b-col>
        </b-row>
      </b-card-body>
      <b-card-footer class="d-flex justify-content-center" v-if="mostrarDetalhes">
        <b-button variant="secondary" @click="cancelar">Fechar</b-button>
        <b-button variant="primary" v-if="temPrivilegioAcessarCarrinho()" @click="adicionarAoCarrinho" class="ml-2">Adicionar ao Carrinho</b-button>
      </b-card-footer>
    </b-card>
    <b-modal v-model="modalAnexoAberto" size="lg" :title="prefix + title + ' > Cadastrar Anexo'" hide-footer>
      <CadastrarAnexo :id='id' @fecharModal="fecharModalAnexo" />
    </b-modal>
  </b-modal>
</template>

<script>
import ResourceService from "@/core/api/ResourceService"
import { mapState } from "vuex"
import CadastrarAnexo from "./CadastrarAnexo"
import verificaPrivilegio from "@/utils/VerificaPrivilegio"
import PrivilegiosEnum from "@/core/utils/PrivilegioEnum"


export default {
  name: "DescricaoDetalhadaProduto",
  components: {
    CadastrarAnexo
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
    mostrarDetalhes: {
      type: Boolean,
      default: true,
    },
    prefix:{
        type:String,
        default:"",
      },
      title:{
        type:String,
        default: "Item Bem Permanente > Descrição Detalhada"
      }

  },
  data() {
    return {
      modalAberto: true,
      modalAnexoAberto: false,
      result: {
        produtoCatalogo: {},
        imagens: [],
      },
      form: {
        quantidade: 1,
      },
      fotoSelecionada: '',
    }
  },
  computed: {
    ...mapState({
      produtoId: state => state.produtoId,
    }),
    valorTotal() {
      const valorUnitario = this.result.produtoCatalogo.valorEstimado || 0
      const quantidade = this.form.quantidade || 0
      return valorUnitario * quantidade
    }
  },
  methods: {
    temPrivilegioAcessarCarrinho() {
      return verificaPrivilegio(PrivilegiosEnum.CATALOGO_PATRIMONIO_ACESSAR_CARRINHO);

    },

    temPrivilegioAcessarAnexo() {
      return verificaPrivilegio(PrivilegiosEnum.CONFIGURACAO_CATALOGO_ACESSAR_ANEXOS);

    },

    adicionarAoCarrinho() {
      if (this.form.quantidade <= 0) {
        this.$bvToast.toast('A quantidade não pode ser menor que zero.', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
        return
      }
      this.$emit('adicionarAoCarrinho', {
        id: this.result.produtoCatalogo.id,
        apelido: this.result.produtoCatalogo.apelido,
        produtoCatalogo: this.result.produtoCatalogo,
        quantidade: this.form.quantidade,
        valorUnitario: this.result.produtoCatalogo.valorEstimado,
      })
      this.$notify({ type: 'success', message: 'Produto adicionado ao carrinho com sucesso!' })
      this.cancelar()
    },
    cancelar() {
      this.$emit('fecharModal')
    },
    convertByteArrayToImage(byteArray) {
      if (!byteArray) return ''
      return `data:image/jpeg;base64,${byteArray}`
    },
    async loadProduto() {
      if (this.id) {
        const { data } = await this.$service.findById(this.id)
        this.result = data
        this.fotoSelecionada = this.result.imagens.length > 0 ? this.convertByteArrayToImage(this.result.imagens[0]) : ''
      }
    },
    selecionarFoto(foto) {
      this.fotoSelecionada = foto
    },
    formatCurrency(value) {
      return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value)
    },
    abrirModalAnexo() {
      this.modalAnexoAberto = true
    },
    fecharModalAnexo() {
      this.modalAnexoAberto = false
    }
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/catalogoconsulta`)
    await this.loadProduto()
  },
}
</script>

<style scoped>
.mb-3 {
  margin-bottom: 1rem;
}

.thumbnail-container {
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
}

.thumbnail-container img {
  width: 100px;
  height: 100px;
  object-fit: cover;
}

.d-flex {
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
}

.especificacao-container {
  max-height: 200px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #ccc;
  margin-bottom: 1rem;
}

.especificacao {
  white-space: pre-wrap;
}

.b-img-max-half {
  max-height: 50%;
  min-height: 50%;
  height: auto;
}

.b-card-footer {
  border-top: 1px solid #dee2e6;
  padding: 0.75rem 1.25rem;
}
</style>
